<template>
  <v-card>
    <v-toolbar card dense color="success">
      <v-toolbar-title class="white--text">{{ 'app.pages.subscription' | trans }}</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <div v-if="!!current_subscription_type_name">
        <p v-html="activeSubscriptionHTML()"></p>
        <div v-if="account_expires_in <= 14">
          <p v-if="account_expires_in === 0">
            {{ 'app.pages.home.subscription_expires_today' | trans }}
          </p>
          <p v-else v-html="subscriptionExpiresInHTML()">
          </p>
          <v-btn
              v-if="current_subscription_type_name === 'Abonament testowy'"
              :href="buy_subscription_url"
              color="success"
          >
            {{ 'app.pages.home.buy_subscription' | trans }}
          </v-btn>
        </div>
      </div>
      <div v-else>
        {{
          (userRole === DIETITIAN_FREE() ? 'app.pages.home.active_subscription_lacks_free_account' : 'app.pages.home.active_subscription_lacks') | trans
        }}<br><br>
        <v-btn
            :href="buy_subscription_url"
            color="success"
        >
          {{ 'app.pages.home.buy_subscription' | trans }}
        </v-btn>
      </div>
      <v-btn
          v-if="show_start_discount_url"
          :href="start_discount_url"
          color="warning"
      >
        {{ 'app.pages.home.get_start_discount' | trans }}
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import {trans} from "../../app";
import {mapGetters} from "vuex";
import {DIETITIAN_FREE} from "../../utils/roles";

export default {
  props: {
    current_subscription_type_name: {
      type: String,
    },
    last_subscription_end_date: {
      type: String
    },
    account_expires_in: {
      type: Number
    },
    buy_subscription_url: {
      type: String
    },
    start_discount_url: {
      type: String
    },
    show_start_discount_url: {
      type: Boolean
    },
  },
  computed: {
    ...mapGetters([
        'userRole',
    ])
  },
  methods: {
    DIETITIAN_FREE() {
      return DIETITIAN_FREE
    },
    subscriptionExpiresInHTML() {
      return trans('app.pages.home.subscription_expires_in', {"expires_in": this.account_expires_in});
    },
    activeSubscriptionHTML() {
      return trans('app.pages.home.active_subscription', {
        "last_subscription_end_date": this.last_subscription_end_date,
        "current_subscription_type_name": this.current_subscription_type_name
      });
    }
  }
}
</script>

<style scoped>
.v-card__text{
  font-size:14px;
  font-family: 'Open Sans', sans-serif;
}
</style>
